"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSoccerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.74 21.225c1.46-.59 2.75-1.514 3.773-2.678a9.962 9.962 0 002.476-7.06 9.944 9.944 0 00-1.323-4.533 10.02 10.02 0 00-6.276-4.719 10.025 10.025 0 00-2.905-.274C6.2 2.229 2 6.597 2 11.948c0 5.523 4.477 10 10 10a9.971 9.971 0 003.74-.723zm-1.96-1.476a8.023 8.023 0 01-3.582-.005l.1-.076-.913-2.653 1.192-1.728h2.844l1.17 1.733-.912 2.652.102.077zm1.21-15.224l-2.16 1.57v2.177l2.514 1.826 1.878-.433 1.037-2.7a8.023 8.023 0 00-3.269-2.44zm4.964 8.283l-.036.024-2.055-1.664-2.215.511-.884 2.721 1.119 1.658 2.884.05.022.072a7.951 7.951 0 001.165-3.372zM9.01 4.525A8.023 8.023 0 005.744 6.96l1.027 2.675 1.901.452 2.55-1.852V6.132L9.01 4.525zm-4.965 8.28a7.95 7.95 0 001.15 3.35l.015-.05 2.884-.05 1.143-1.658-.889-2.734-2.179-.518-2.082 1.687-.042-.028z' }))); };
exports.default = SvgSoccerOutline;
//# sourceMappingURL=SoccerOutline.js.map